import React, { useState, useEffect } from 'react';
import MovieItem from './MovieItem';
import axios from 'axios';

const MovieList = () => {

    const [items, setItems] = useState([]);

    useEffect(() => {
        const key = "05b803ad4a902190cbd370a3562b4d93";

        const getMovieData = async () => {
            const response = await axios.get(`https://api.themoviedb.org/3/trending/all/day?api_key=${key}`);

            setItems(response.data.results);
            console.log(response.data.results);
            console.log(response.data.results.length);
        }
        getMovieData();
    }, [])


    return (
        <div>
            <div className="container">
                <div className="row">

                    {items.map((item) => (

                        <MovieItem key={item.id} item={item} />

                    ))}

                </div>
            </div>
        </div>
    )
}

export default MovieList